import { PluginObject } from "vue/types/plugin";

import { Code } from "@/interfaces/interfaces";

export class Storage {
  setToken(token: string): Code {
    try {
      localStorage.setItem("token", token);
      return Code.SUCCESS;
    } catch (error) {
      return Code.LOCAL_STORAGE_SET_ERR;
    }
  }
  getToken(): string | null {
    return localStorage.getItem("token");
  }

  removeToken() {
    localStorage.removeItem("token");
  }

  getLanguage(): string | null {
    return localStorage.getItem("language");
  }

  setLanguage(language: string) {
    try {
      localStorage.setItem("language", language);
      return Code.SUCCESS;
    } catch (error) {
      return Code.LOCAL_STORAGE_SET_ERR;
    }
  }
  setPendingStatus() {
    try {
      localStorage.setItem("pendingStatusMsg", "true");
      return Code.SUCCESS;
    } catch (error) {
      return Code.LOCAL_STORAGE_SET_ERR;
    }
  }

  isPendingStatus() {
    const v = localStorage.getItem("pendingStatusMsg") === "true";
    localStorage.removeItem("pendingStatusMsg");
    return v;
  }
}

export const storage = new Storage();

export const StoragePlugin: PluginObject<any> = {
  install: (vue, options) => {
    vue.prototype.$storage = storage;
  },
};
